// Copyright (c) 2022 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {completePercentageDebit} from './debit';
import {postDebit} from '../../shared/repositories';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const updatePercentage = percentageValue =>

    dispatch => {

        dispatch({
            percentageValue,
            type: actions.UPDATE_TCSM_PERCENTAGE_DEBIT_VALUE
        });

    };

export const updatePercentageDebit = (debit, auditNumber) =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await postDebit(debit);

            successAlertBar(translate('DEBIT_SUBMITTED_SUCCESSFULLY'));

            completePercentageDebit(auditNumber)(dispatch);

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/action-creators/update-percentage.js